import { Routes } from '@angular/router';
import { canActivatePerm, GlobalScopes, i18nResolver } from 'O3_core';
import { JOB_DEFINITION_RESOURCE } from './job-definition/constants/job-definition.constants';
import enTranslations from './dashboard/locales/en/resources.json';
import roTranslations from './dashboard/locales/ro/resources.json';

export const routes: Routes = [
  {
    path: '',
    canActivate: [canActivatePerm(JOB_DEFINITION_RESOURCE, GlobalScopes.Filter)],
    data: {
      viewKey: 'JobScheduler_Dashboard',
      enTranslations,
      roTranslations,
    },
    resolve: { i18nResolverData: i18nResolver },
    loadComponent: () =>
      import('./dashboard/dashboard').then((c) => c.JobSchedulerDashboard),
  },
  {
    path: 'definitions',
    loadChildren: () =>
      import('./job-definition/job-definition.routes').then((c) => c.routes),
  },
  {
    path: 'executions',
    loadChildren: () =>
      import('./job-execution/job-execution.routes').then((c) => c.routes),
  },
];
